<template>
    <div class="main-list-wrap petition_details_wrap">
        <div class="pad20">
            <template >
                <vs-row v-if="beneficiaryDocsList && checkProperty(beneficiaryDocsList,'length')>0"  >
                    <vs-col class="padl0 padr0">
                    <div class="card-panels pad0">
                        <vs-card>
                        <div slot="header" >
                            <h3>Beneficiary Documents</h3> 
                        </div>
                            <div>
                                <template v-for="(item ,ind ) in  beneficiaryDocsList"  >
                                    <div class="documents__list"  >
                                        <div class="documents__title" @click="downloadfile(item)">
                                            <figure> 
                                                <img v-if="checkFileFormat(item['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                                <img v-else src="@/assets/images/main/icon-img.svg" />
                                            </figure> 
                                            <span>{{item.name}}<br/><small>{{getformated(item)}}</small></span>
                                        </div>
                                        <div class="documents__actions">
                                            <button  @click="downloadfile(item,false,true)" class="view-btn">View</button>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        
                        </vs-card>
                    </div>
                    </vs-col>
                </vs-row>
            </template>
            <template >
                <vs-row v-if="formAndLettersList && checkProperty(formAndLettersList,'length')>0"  >
                    <vs-col class="padl0 padr0">
                    <div class="card-panels pad0">
                        <vs-card>
                        <div slot="header" >
                            <h3 v-if="petition.subTypeDetails.id ==15" >Audit Response</h3> 
                            <h3 v-else>Forms and Letters</h3> 
                        </div>
                            <div>
                                <template v-for="(item ,ind ) in  formAndLettersList"  >
                                    <div class="documents__list"  >
                                        <div class="documents__title" @click="downloadfile(item)">
                                            <figure> 
                                                <img v-if="checkFileFormat(item['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                                <img v-else src="@/assets/images/main/icon-img.svg" />
                                            </figure> 
                                            <span>{{item.name}}<br/><small>{{getformated(item)}}</small></span>
                                        </div>
                                        <div class="documents__actions">
                                            <button  @click="downloadfile(item,false,true)" class="view-btn">View</button>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        
                        </vs-card>
                    </div>
                    </vs-col>
                </vs-row>
            </template>
            <template >
                <vs-row v-if="scannedDocsList && checkProperty(scannedDocsList,'length')>0"  >
                    <vs-col class="padl0 padr0">
                    <div class="card-panels pad0">
                        <vs-card>
                        <div slot="header" >
                            <h3>Scanned Documents</h3> 
                        </div>
                            <div>
                                <template v-for="(item ,ind ) in  scannedDocsList"  >
                                    <div class="documents__list"  >
                                        <div class="documents__title" @click="downloadfile(item)">
                                            <figure> 
                                                <img v-if="checkFileFormat(item['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                                <img v-else-if="checkFileFormat(item['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                                <img v-else src="@/assets/images/main/icon-img.svg" />
                                            </figure> 
                                            <span>{{item.name}}<br/><small>{{getformated(item)}}</small></span>
                                        </div>
                                        <div class="documents__actions">
                                            <button  @click="downloadfile(item,false,true)" class="view-btn">View</button>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        
                        </vs-card>
                    </div>
                    </vs-col>
                </vs-row>
            </template>
        </div>
        <NoDataFound :loading="false" ref="NoDataFoundRef" :update_loading="updateNodataLoading()"    content=""  heading="No Documents Found." type='documents'   v-if="(formAndLettersList<=0 && beneficiaryDocsList <=0 && scannedDocsList<=0 )"/>
    </div>
</template>

<script>
import moment from "moment";
import * as _ from "lodash";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NoDataFound from "@/views/common/noData.vue";
import { XIcon } from 'vue-feather-icons'
import FileUpload from "vue-upload-component/src";
import caseQuestionnaireDocs from "@/views/forms/caseQuestionnaireDocs.vue";
import downLoadCaseDocuments from "@/views/petition/downLoadCaseDocuments.vue";
import JQuery from "jquery";
export default {
   provide() {
        return {
            parentValidator: this.$validator,
        };
    },
  components: {
    downLoadCaseDocuments,
    caseQuestionnaireDocs,
    FileUpload,
    VuePerfectScrollbar,
    NoDataFound,
    XIcon
  },
  data() {
    return {
        documentList:[],
        formAndLettersList:[],
        beneficiaryDocsList:[],
        scannedDocsList:[]
    }
  },
  props: {
    petition: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getformated(item) {
            if( item.createdOn){
                return (
                "Downloaded On  " +
                moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a") +
                " - Downloaded by " + item.createdByName
            );

            }else if(item.createdOn){
                return (
                "Downloaded On  " +
                moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a") +
                " - Downloaded by " + item.createdByName 
            );

            }else{
                return 'Downloaded by '+ item.createdByName
            }
        },
    updateNodataLoading(){
      setTimeout(()=>{
        this.updateLoading(false);
      } ,100)
      return true;

    },
    getDocumentsList(){
        let payLoad={
            petitionId: this.checkProperty(this.petition,'_id') ,
		    categories: ['forms_and_letters','beneficiary_docs','scanned_copies'],
            entityType:'case',
            typeName: this.checkProperty(this.petition,'typeDetails','name'),
            subTypeName:this.checkProperty(this.petition,'subTypeDetails','name'),
        }
        if(this.checkProperty(this.petition,'subTypeDetails','id')==15){
            payLoad['entityType'] ='perm'
        }
        let path = '/petition-common/get-recent-downloads'
        this.$store.dispatch("commonAction" ,{data:payLoad,'path':path}).then((response) =>{
            let list = response
            this.formAndLettersList = _.filter(list, (item) => {
                return item.category == 'forms_and_letters'
            });
            this.beneficiaryDocsList = _.filter(list, (item) => {
                return item.category == 'beneficiary_docs'
            });
            this.scannedDocsList = _.filter(list, (item) => {
                return item.category == 'scanned_copies'
            });
          })
          .catch((err) =>{})

    },
    downloadfile(item,download = false, viewmode = false){
        item.download = download;
        item.viewmode = viewmode;
        this.$emit("download_or_view" ,item);
    }
  },
  mounted() {
    this.getDocumentsList()
  },
}
</script>